import { Injectable } from '@angular/core';
import { Units } from '../app.config';
import {PaginationParams, IDangoPaginationParams} from '../_models/generic';


export class Utilities {

  public static convertPaginationParameters(params: PaginationParams): IDangoPaginationParams {
    // switch out the sorting order asending/descending to match django ordering flags
    // Angular mat table ordering options are 'asc'
    const _params: IDangoPaginationParams = {
      pageSize: params.pageSize,
      page: params.page,
      ordering: (params.orderingDirection  === 'desc' ? '-' : '') + params.ordering,
      search: params.search
    };
    return _params;
  }

  public static encodeParamUrl(obj: Object): string {
    let _str = '';
    for (const field of Object.keys(obj)) {
        if (_str != "") {
            _str += "&";
        }
        _str += field + "=" + encodeURIComponent(obj[field]);
    }
    return _str;
  }

  constructor(private _units: Units) { }

  public milesToKm(miles: number): number {
    let _km:number;
    let _metersInMile = this._units.metersToMile;
    return _km = miles * _metersInMile;
  }

  public kmToMiles(kms: number): number {
    let _mile:number;
    let _metersInMile = this._units.metersToMile;
    return _mile = kms / _metersInMile;
  }

}




// WEBPACK FOOTER //
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/_utilities/Utilities.ts